import React from "react";

import type {
    FreeformTile as TileValue,
    SmallLinkTiles as Value,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Clickable } from "../Clickables";
import { Eyebrow, Heading } from "../RichTextStreamBlock";

import styles from "./SmallLinkTiles.module.scss";

const TileLink = ({
    link,
    className,
    children,
}: {
    link: TileValue["link"];
    className: string;
    children: React.ReactNode;
}) => {
    if (!link?.url) return <div className={className}>{children}</div>;
    return (
        <Clickable simpleLink={link} className={className}>
            {children}
        </Clickable>
    );
};

const Tile = ({ value }: { value: TileValue }) => (
    <TileLink link={value.link} className={styles.tile}>
        <div className={styles.text}>
            {value.eyebrow?.text && (
                <Eyebrow value={value.eyebrow} size="small" />
            )}
            {value.heading && (
                <Heading className={styles.heading} value={value.heading} />
            )}
            {value.cta_text && (
                <span className={styles.cta} aria-hidden="true">
                    {value.cta_text}
                </span>
            )}
        </div>
        {value.image && (
            <ImageChooserBlock
                value={value.image}
                attrs={{ className: styles.imageWrapper }}
                imageAttrs={{
                    className: styles.image,
                    alt: "",
                }}
                sizes="200px"
            />
        )}
    </TileLink>
);

export const SmallLinkTiles = ({ value }: { value: Value }) => {
    if (!value.tiles) return <></>;
    const wrapClassName =
        value.tiles.length === 3 ? styles.gridWrapThree : styles.gridWrapTwo;
    return (
        <div className={wrapClassName}>
            <div className={styles.grid}>
                {value.tiles.map((tile, index) => (
                    <React.Fragment key={tile.id}>
                        {index > 0 && (
                            <div aria-hidden="true" className={styles.spacer} />
                        )}
                        <Tile value={tile.value} />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};
